import React from "react";


import "../styles/imagegrid.css";

import CardGrid from "../components/CardGrid";
import ImageViewer from "../components/ImageViewer";


function weightedRand(spec) {
    var table = [];
    for (let i in spec) {
        for (let j = 0; j < spec[i] * 10; j++) {
            table.push(i);
        }
    }

    return function() {
        return table[Math.floor(Math.random() * table.length)];
    }
}

function batchRand(batchsize) {
    var k = 0, m = 0;

    return function() {
        let i = Math.floor(k++ / 2) % batchsize

        if (i == 0) {
            m = Math.floor(Math.random() * batchsize)
        }

        return (i == m) ? 2 : 1;
    }
}

var sizes = batchRand(4); //weightedRand({ 1: 0.8, 2: 0.2 });

function GridItem(props) {
    const { item, ...rest } = props;

    var size = sizes();

    return (
        <ImageViewer 
            className={"size-" + size}
            src={item.src}
            author={item.author}
            {...rest}
        />
    );
}

export default function ImageGrid(props) {

    return (
        <section>
            <CardGrid 
                className={"image-grid"}
                component={{ "type": GridItem }}
                {...props}
            />
        </section>
    );
}
